import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ComponentProxy } from '../deferred/component-loader.service';
import { ComponentProxyDirective } from '../deferred/component-proxy.directive';

@Component({
    selector: 'ms-popup-proxy',
    template: ` <ng-container [msComponentProxy]="proxy" (componentLoaded)="onComponentLoaded()" />`,
    imports: [ComponentProxyDirective],
})
export class PopupProxyComponent {
    @Input() proxy: ComponentProxy;

    @Output() componentLoaded = new EventEmitter<void>();

    onComponentLoaded(): void {
        this.componentLoaded.next();
    }
}
